import React from "react";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

const cn = (...inputs) => twMerge(clsx(inputs));

/** Label + control + optional helper text / meta (e.g. a counter) + error, in the app's form style. */
const FormField = ({ label, htmlFor, hint, meta, error, children, className }) => (
  <div className={cn("flex flex-col gap-1.5", className)}>
    {label && (
      <label htmlFor={htmlFor} className="text-xs font-medium text-gray-600 dark:text-gray-300">
        {label}
      </label>
    )}
    {children}
    {(hint || meta) && (
      <div className="flex items-start justify-between gap-3">
        {hint ? <p className="text-[0.65rem] text-gray-500 dark:text-gray-400">{hint}</p> : <span />}
        {meta && <p className="shrink-0 text-[0.65rem] text-gray-500 dark:text-gray-400 tabular-nums">{meta}</p>}
      </div>
    )}
    {error && <p className="text-[0.65rem] text-error-500">{error}</p>}
  </div>
);

export default FormField;
